// Button script for child anchor tag
export function CustomBtn() {
  //Script for the without link btn style
  let buttonElementCustom = document.querySelectorAll(".ge-btn, .ge-txt-btn");
  if (buttonElementCustom.length) {
    for (let buttonElementCustomItem = 0; buttonElementCustomItem < buttonElementCustom.length; buttonElementCustomItem++) {
      if (buttonElementCustom[buttonElementCustomItem].querySelector('a')) {
        buttonElementCustom[buttonElementCustomItem].classList.add('ge-btn-with-link');
      }
    }
  }
}